import { translate } from "app/filters/i18nFilter";
import type { ReactElement } from "react";
import type SignalsTooltipViewModel from "../../../models/view/signals-tooltip/SignalsTooltipViewModel";
import SignalsTooltipButtonLink from "../shared/SignalsTooltipButtonLink/SignalsTooltipButtonLink";
import SignalsTooltipContent from "../shared/SignalsTooltipContent/SignalsTooltipContent";
import SignalsTooltipTableView from "../shared/SignalsTooltipTableView/SignalsTooltipTableView";
import { StyledMoreItemsText } from "../shared/styles";
import SignalsTooltip from "../SignalsTooltip/SignalsTooltip";
import { TOOLTIP_DEBOUNCE_TIME } from "./const";

type Props = {
    signalSubType: string;
    children: ReactElement | string | number;
    redirectLink: URL["href"];
    createViewModel(itemsLimit: number): SignalsTooltipViewModel;
    onViewAll(): void;
};

const SignalsCountriesTooltip = (props: Props) => {
    const { signalSubType, children, redirectLink, createViewModel, onViewAll } = props;

    const renderOverLimitView = (props: { items: SignalsTooltipViewModel["otherItems"] }): ReactElement => {
        const { items } = props;

        return (
            <StyledMoreItemsText>
                {translate("si.signals.table-columns.tooltip.text.more", {
                    count: items.length,
                })}
            </StyledMoreItemsText>
        );
    };

    return (
        <SignalsTooltip
            debounce={TOOLTIP_DEBOUNCE_TIME}
            content={
                <SignalsTooltipContent
                    title={translate(`si.signals.table-columns.tooltip.title.${signalSubType}`)}
                    footer={
                        <SignalsTooltipButtonLink
                            text={translate(`si.signals.table-columns.tooltip.view-all.${signalSubType}`)}
                            redirectLink={redirectLink}
                            onClick={onViewAll}
                        />
                    }
                >
                    <SignalsTooltipTableView
                        createViewModel={createViewModel}
                        renderOverLimitView={renderOverLimitView}
                    />
                </SignalsTooltipContent>
            }
        >
            {children}
        </SignalsTooltip>
    );
};

export default SignalsCountriesTooltip;
